import type {PullRequestAliveData} from './use-refetch-on-alive-update'
import {useInvalidateOnAliveUpdate} from '@github-ui/use-invalidate-on-alive-update'
import {useReviewRequestsQueryKey} from '../components/overview/data/route-queries'
import type {AliveChannels} from '../page-data/payloads/header'

const filter = (data: PullRequestAliveData) => Boolean(data.event_updates?.reviewers_updated)
const emptyQueryKey = [] as const

export function useReviewersLiveUpdates(aliveChannels: AliveChannels | undefined): void {
  const queryKey = useReviewRequestsQueryKey()

  useInvalidateOnAliveUpdate(queryKey ? (aliveChannels?.pullRequest ?? '') : '', queryKey ?? emptyQueryKey, {
    filter,
  })
}
